import { docsBaseUrl } from '../contexts/environment';

const docsUrls = {
  root: '',
  awsUpdatePermissions: '/user-guide/aws/permissions/aws-update-permissions',
  awsSourcePermissionsChangelog:
    '/whats-new/permissions-changelogs/aws/source-permissions',
  awsRestorePermissionsChangelog:
    '/whats-new/permissions-changelogs/aws/restore-permissions',
  gcpSourcePermissionsChangelog:
    '/whats-new/permissions-changelogs/gcp/source-permissions',
  gcpRestorePermissionsChangelog:
    '/whats-new/permissions-changelogs/gcp/restore-permissions',
  azureSourcePermissionsChangelog:
    '/whats-new/permissions-changelogs/azure/source-permissions',
  azureRestorePermissionsChangelog:
    '/whats-new/permissions-changelogs/azure/restore-permissions',
  awsCustomizeRestoreServerConfig:
    '/user-guide/aws/restore-accounts/aws-customize-restore-server-configuration',
  azureSqlServerConfiguration:
    '/user-guide/azure/resources/sql-server-on-azure-vms#configuration',
  gcpCustomizeRestoreServerConfig:
    '/user-guide/gcp/restore-projects/gcp-customize-restore-server-configuration',
  vaultSelfManagedKeys:
    '/user-guide/backing-up/vaults/about-self-managed-vault-keys',
  restoreAccountNetworkConnectivity:
    '/user-guide/restoring/restore-accounts/about-restore-accounts#the-restore-server-and-its-network-connectivity',
  queryDatabaseSnapshots:
    '/user-guide/searching-exploring-and-querying/query/query-database-snapshots',
  aboutNotificationPolicies:
    '/user-guide/monitoring/notification-policies/about-notification-policies',
  notificationPolicySlack:
    '/user-guide/monitoring/notification-policies/manage-notification-policies/slack',
  notificationPolicySns:
    '/user-guide/monitoring/notification-policies/manage-notification-policies/amazon-sns',
  notificationPolicyEmail:
    '/user-guide/monitoring/notification-policies/manage-notification-policies/email',
  notificationPolicyServiceNow:
    '/user-guide/monitoring/notification-policies/manage-notification-policies/service-now',
  notificationPolicySplunk:
    '/user-guide/monitoring/notification-policies/manage-notification-policies/splunk',
  notificationPolicyDatadog:
    '/user-guide/monitoring/notification-policies/manage-notification-policies/datadog',
  selfManagedVaultsManageAccounts:
    '/user-guide/administration/self-managed-vaults/manage-vault-accounts',
  aboutUsers: '/user-guide/access-management/users/about-users',
  aboutSamlSso: '/user-guide/access-management/saml-sso/about-saml-sso',
  samlSsoGroups:
    '/user-guide/access-management/saml-sso/about-saml-sso#saml-sso-access-is-managed-through-groups',
  aboutApiCredentials:
    '/user-guide/access-management/api-credentials/about-api-credentials',
  aboutRolesAndPermissions:
    '/user-guide/access-management/roles-and-permissions/about-roles-and-permissions',
  awsConnectSourceAccounts:
    '/user-guide/aws/source-accounts/aws-connect-source-accounts',
  awsEks: '/user-guide/aws/resources/eks',
  azureConnectSourceSubscriptions:
    '/user-guide/azure/source-subscriptions/azure-connect-source-subscriptions',
  gcpConnectSourceProjects:
    '/user-guide/gcp/source-projects/gcp-connect-source-projects',
  aboutDiscovery: '/user-guide/backing-up/discovery/about-discovery',
  awsConnectRestoreAccounts:
    '/user-guide/aws/restore-accounts/aws-connect-restore-accounts',
  azureConnectRestoreSubscriptions:
    '/user-guide/azure/restore-subscriptions/azure-connect-restore-subscriptions',
  gcpConnectRestoreProjects:
    '/user-guide/gcp/restore-projects/gcp-connect-restore-projects',
  aboutVaults: '/user-guide/backing-up/vaults/about-vaults',
  aboutBackupPolicies:
    '/user-guide/backing-up/backup-policies/about-backup-policies',
  aboutObjectFilters:
    '/user-guide/backing-up/object-filters/about-object-filters',
  awsDynamodbConfigurationBackups:
    '/user-guide/aws/resources/dynamodb#how-configuration-affects-backups',
  aboutBackupPostureControls:
    '/user-guide/monitoring/backup-posture-controls/about-controls',
  aboutRansomwareDetection:
    '/user-guide/monitoring/ransomware-detection/about-ransomware-detection',
  awsRestoreVpcEndpoints:
    '/user-guide/aws/restore-accounts/aws-restore-server-requirements#vpc-endpoints-for-subnets-without-internet-access',
  aboutActionApprovals:
    '/user-guide/access-management/action-approvals/about-action-approvals',
  manageApprovalRules:
    '/user-guide/access-management/action-approvals/manage-approval-rules',
  ec2EncryptedVolumeAccess:
    '/user-guide/aws/resources/ec2#encrypted-volumes-access',
} as const;

export type DocsUrlKey = keyof typeof docsUrls;
export const getDocsUrl = (key: DocsUrlKey) => `${docsBaseUrl}${docsUrls[key]}`;
